import React from 'react';
import Layout from '../../components/Layout';
import AppointmentForm from '../../components/AppointmentForm/AppointmentForm';
import SectionTitle from '../../components/SectionTitle/SectionTitle';
import './Contactus.scss';

const Contactus = () => {
    return (
      <Layout>
        <section className="section-bg section-common contact-section">
          <SectionTitle
            title="Book Your Dental Appointment"
            description="Ready to take care of your dental health? Book an appointment with our experienced team. We offer flexible scheduling and personalized care for all your dental needs."
          />
        </section>
        <section
          className="contact-form-area"
          data-aos="fade-up"
          data-aos-duration="2000"
        >
          <AppointmentForm />
        </section>
      </Layout>
    );
};

export default Contactus;